module.exports = __webpack_public_path__ + "img/pause.b2dbf92f.svg";